/**
 * Parses CSV text into rows of cells. Handles:
 * - UTF-8 BOM
 * - Quoted cells with embedded commas, newlines, and `""` escapes
 * - CRLF, LF, and lone-CR (old Mac) line endings
 *
 * Returns `string[][]` where each inner array is one row's cells.
 */
export function parseCsv (text: string): string[][] {
	if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1);
	const rows: string[][] = [];
	let row: string[] = [];
	let cell = '';
	let inQuotes = false;
	for (let i = 0; i < text.length; i++) {
		const ch = text[i];
		if (inQuotes) {
			if (ch === '"') {
				if (text[i + 1] === '"') { cell += '"'; i++; }
				else { inQuotes = false; }
			} else {
				cell += ch;
			}
		} else {
			if (ch === '"') {
				inQuotes = true;
			} else if (ch === ',') {
				row.push(cell);
				cell = '';
			} else if (ch === '\r') {
				row.push(cell);
				rows.push(row);
				row = [];
				cell = '';
				// CRLF: consume the following LF so we don't emit a blank row
				if (text[i + 1] === '\n') i++;
			} else if (ch === '\n') {
				row.push(cell);
				rows.push(row);
				row = [];
				cell = '';
			} else {
				cell += ch;
			}
		}
	}
	if (cell.length > 0 || row.length > 0) {
		row.push(cell);
		rows.push(row);
	}
	return rows;
}
